import { CLIMATE, Climate } from '../../../../../../constants/Climate';
import { Crop } from '../../../../../../constants/CropConstants';
import { SEEDBED_QUALITY, SeedbedQuality } from '../../../../../../constants/SeedbedQuality';
import { SOIL_TYPE, SoilType } from '../../../../../../constants/SoilType';
import { Identifier } from '../../../../SeedingCalculator';
import { getSeedRate, SeedRateResult } from '../../../../DanishSeedingModelV1SeedRate';
import { SeedingCalculatorStrategy } from './SeedingCalculatorStrategy';

export class DanishSeedingCalculatorV1 extends SeedingCalculatorStrategy {
  identifier = Identifier.DANISH_SEEDING_MODEL;
  version = 1;

  protected getSeedRate(crop: Crop, date: Date): SeedRateResult {
    return getSeedRate(crop, date);
  }

  protected calculatePrescriptionLimitForHybridCrop(
    unitsPerSack: number,
    sackWeight: number,
    seedRate: number,
    organic: boolean,
    climate: Climate
  ): number {
    let result = (sackWeight / unitsPerSack) * seedRate * this.climateToPercentage(climate);
    if (organic) result *= 1.2;
    return Math.round(result);
  }

  protected calculatePrescriptionLimitForNonHybridCrop(
    TGW: number,
    germinationPercentage: number,
    seedbedQuality: SeedbedQuality,
    soilType: SoilType,
    seedRate: number,
    organic: boolean,
    climate: Climate
  ): number {
    let result =
      seedRate *
      (TGW / germinationPercentage) *
      this.seedbedQualityToPercentage(seedbedQuality) *
      this.soilTypeToPercentage(soilType) *
      this.climateToPercentage(climate);
    if (organic) result *= 1.2;
    return Math.round(result);
  }

  protected seedbedQualityToPercentage(seedbedQuality: SeedbedQuality): number {
    switch (seedbedQuality) {
      case SEEDBED_QUALITY.GOOD:
        return 0.9;
      case SEEDBED_QUALITY.NORMAL:
        return 1;
      case SEEDBED_QUALITY.BAD:
        return 1.1;
      default:
        return 1;
    }
  }

  protected climateToPercentage(climate: Climate): number {
    switch (climate) {
      case CLIMATE.NORMAL:
        return 1;
      case CLIMATE.CHILLY:
        return 1.08;
      case CLIMATE.MILD:
        return 0.92;
      default:
        return 1;
    }
  }

  protected soilTypeToPercentage(soilType: SoilType): number {
    switch (soilType) {
      case SOIL_TYPE.SANDY:
        return 0.92;
      case SOIL_TYPE.HUMIC:
        return 0.85;
      case SOIL_TYPE.HEAVY_CLAY:
        return 1.1;
      case SOIL_TYPE.NORMAL:
        return 1;
      default:
        return 1;
    }
  }
}
